module.exports = __webpack_public_path__ + "static/media/visa.a35a05e3.svg";